import { BaseCommand } from './baseCommand';
import Element from '../element';
import { ShaderZawias } from '../shaders/others/shader_zawias';
import { positionManager } from '../positionManager';
import { hingesManager } from '../hingesManager';
import { IShader } from '../shaders/shader';
import { Hinge } from '../hinge';

export class AddHingesToFrontCommand extends BaseCommand {

    private shader: IShader = new ShaderZawias();

    constructor(
        private front: Element,
        scenePreview: any,
        private hinges: Hinge[] = [],
    ) {
        super(scenePreview);
    }

    public execute(): void {
        if (this.hinges.length === 0) {
            this.hinges = hingesManager.getHinges(this.front);
        }
        this.hinges.forEach((hinge) => {
            const model = hinge.model;
            const light = hinge.light;
            const position = this.front.position.clone();
            const shape = this.front.shape.clone();
            this.scenePreview.addElement(model, light, this.shader, position, shape, (x: Element) => {
                positionManager.positionHinge(x, hinge);
                x.bind(this.front);
                this.elements.push(x);
            });
        });
    }
}
